/**
 * Loads an image from the specified URI.
 *
 * @param {string} uri - The URI of the image.
 * @returns {Promise<HTMLImageElement>} - A promise that resolves to the loaded image.
 */
// to convert image tag with src attribute

export const loadImage = (uri) => {
  return new Promise((resolve, reject) => {
    let img = new Image()
    img.onload = () => {
      resolve(img)
    }
    img.onerror = (error) => {
      reject(error)
    }
    img.src = uri
  })
}
/**
 * Draws a checked pattern on a canvas and returns the data URL of the canvas.
 *
 * @param {number} width - The width of the canvas.
 * @param {number} height - The height of the canvas.
 * @param {number} [side=32] - The side length of each square in the checked pattern.
 * @returns {string} - The data URL of the canvas.
 */

// export const drawChecked = () => {
//   const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
//   <path d="M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l96 0 32 0 208 0c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"/>
//  </svg>`
//   // Create an image from the SVG
//   const svgBlob = new Blob([svg], { type: "image/svg+xml" })
//   const url = URL.createObjectURL(svgBlob)

//   return url
// }

// export const drawChecked = (width, height) => {
//   width = 350
//   height = 350
//   console.log(width, height, "point")
//   let canvas = document.createElement("canvas")
//   canvas.width = width
//   canvas.height = height
//   let ctx = canvas.getContext("2d")
//   ctx.fillStyle = "#E6E6E6"
//   ctx.fillRect(0, 0, width, height)

//   let pathData = "M448 80c8.8 0 16 7.2 16 16l0 319.8-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"

//   const path = new Path2D(pathData)
//   ctx.save()

//   ctx.setTransform(0.2, 0, 0, 0.2, width / 4, height / 4)

//   ctx.fillStyle = "#ffffff"
//   ctx.fill(path)
//   ctx.restore()

//   // ctx.fillStyle = "#000000"
//   // for (let i = 0; i < height / side; i++) {
//   //   for (let j = 0; j < width / side; j++) {
//   //     if (xor(i % 2 == 0, j % 2 == 0)) ctx.fillRect(j * side, i * side, side, side)
//   //   }
//   // }
//   return canvas.toDataURL()
// }
// /**
//  * Performs the XOR operation on two boolean values.
//  *
//  * @param {boolean} a - The first boolean value.
//  * @param {boolean} b - The second boolean value.
//  * @returns {boolean} - The result of the XOR operation.
//  */
// const xor = (a, b) => {
//   return (a && !b) || (!a && b)
// }
export const drawChecked = (width, height) => {
  // Determine the size of the square canvas

  const size = Math.min(width, height)

  let canvas = document.createElement("canvas")
  canvas.width = width
  canvas.height = height

  let ctx = canvas.getContext("2d")
  ctx.fillStyle = "#909090"
  ctx.fillRect(0, 0, width, height)

  const ICON_WIDTH = 512

  const SCALING_FACTOR = size / (3 * ICON_WIDTH)

  let pathData = "M448 80c8.8 0 16 7.2 16 16l0 319.8-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"

  const path = new Path2D(pathData)
  ctx.save()
  // a ,d scale
  // b,c skew
  // e,f translation
  ctx.setTransform(SCALING_FACTOR, 0, 0, SCALING_FACTOR, width / 2 - (ICON_WIDTH * SCALING_FACTOR) / 2, height / 2 - (ICON_WIDTH * SCALING_FACTOR) / 2)
  // ctx.setTransform(0.2, 0, 0, 0.2, size / 2 - (512 * 0.2) / 2, size / 2 - (512 * 0.2) / 2)

  ctx.fillStyle = "#ffffff"
  ctx.fill(path)
  ctx.restore()

  return canvas.toDataURL()
}
